import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import api from '../api';

export default function ReadingLog() {
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchRecords = async () => {
            try {
                const { data } = await api.get('/records/');
                setRecords(data);
            } catch (err) {
                setError('독서 기록을 불러오는 데 실패했습니다.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchRecords();
    }, []);

    const handleDelete = async (recordId) => {
        if (window.confirm('정말로 이 독서 기록을 삭제하시겠습니까?')) {
            try {
                await api.delete(`/records/${recordId}/`);
                setRecords(records.filter(record => record.id !== recordId));
            } catch (err) {
                alert('삭제에 실패했습니다.');
                console.error(err);
            }
        }
    };

    if (loading) return <Layout><p>로딩 중...</p></Layout>;
    if (error) return <Layout><p className="message error">{error}</p></Layout>;

    return (
        <Layout>
            <Link to="/main" className="back-link">메인으로</Link>
            <h1>나의 독서 기록</h1>
            <div className="log-container">
                {records.length === 0 ? (
                    <p style={{ textAlign: 'center', gridColumn: '1 / -1' }}>아직 읽은 책이 없습니다.</p>
                ) : (
                    records.map((record) => (
                        <div className="log-item" key={record.id}>
                            {record.book.image ? (
                                <img src={record.book.image} alt={record.book.name} />
                            ) : (
                                <div className="no-image-placeholder"><span>이미지 없음</span></div>
                            )}
                            <h3>{record.book.name}</h3>
                            <p>{record.report}</p>
                            <button onClick={() => handleDelete(record.id)} className="delete-button">삭제</button>
                        </div>
                    ))
                )}
            </div>
        </Layout>
    );
}

